export default "https://cdn-gra.amplement.io/statics/images/placeholder/placeholderLists@2x.png";